<template>
  <div class="adminExperiment">
    <v-card>
      <v-container>
        <v-card class="mb-4">
          <v-card-actions
              @click="restartShow = !restartShow">
            <strong>
              Experiment Command Send
            </strong>
            <v-spacer></v-spacer>
            <v-btn
              icon
            >
              <v-icon>{{ restartShow ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </v-card-actions>
          <v-expand-transition>
            <div v-show="restartShow">
              <v-divider></v-divider>
                <v-col>
                  <v-row>
                    <v-col>
                      <v-select
                        :items="experiments"
                        item-text="text"
                        item-value="value"
                        v-model="restartForm.experiment"
                        label="Experiment"
                      ></v-select>
                    </v-col>
                    <v-col>
                      <v-select
                        :items="equipment_ids"
                        item-text="text"
                        item-value="value"
                        v-model="restartForm.equipment_id"
                        label="Equipment ID"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-select
                        :items="device_ids"
                        item-text="text"
                        item-value="value"
                        v-model="restartForm.device_id"
                        label="Device ID"
                      ></v-select>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :items="commands"
                        v-model="restartForm.command"
                        clearable
                        label="Command"
                      ></v-text-field>
                    </v-col>
                    
                  </v-row>
                  <v-btn class="ma-4" color="primary" @click="restartDialog = true;"
                    >Send Command</v-btn
                  >
              </v-col>
            </div>
          </v-expand-transition>
        </v-card>
        <v-card class="mb-4">
          <v-card-actions
              @click="resetDataShow = !resetDataShow">
            <strong>
              Reset Experiment Data
            </strong>
            <v-spacer></v-spacer>
            <v-btn
              icon
            >
              <v-icon>{{ resetDataShow ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </v-card-actions>
          <v-expand-transition>
            <div v-show="resetDataShow">
              <v-divider></v-divider>
                <v-col>
                  <v-row>
                    <v-col>
                      <v-select
                        :items="experiments"
                        item-text="text"
                        item-value="value"
                        v-model="resetForm.experiment"
                        label="Experiment"
                      ></v-select>
                    </v-col>
                    <v-col>
                      <v-select
                        :items="equipment_ids"
                        item-text="text"
                        item-value="value"
                        v-model="resetForm.equipment_id"
                        label="Equipment ID"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-select
                        :items="device_ids"
                        item-text="text"
                        item-value="value"
                        v-model="resetForm.device_id"
                        label="Device ID"
                      ></v-select>
                    </v-col>
                    <v-col>

                    </v-col>
                  </v-row>
                  <v-btn class="ma-4" color="error" @click="resetDialog = true; "
                    >Reset Data</v-btn
                  >
              </v-col>
            </div>
          </v-expand-transition>
        </v-card>
      </v-container>
    </v-card>
    <v-dialog v-model="restartDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Confirm Sending Command?
        </v-card-title>

        <v-card-text>
          <v-simple-table>
            <tr>
              <td>Experiment:</td>
              <td>
                {{ restartForm.experiment }}
              </td>
            </tr>
            <tr>
              <td>Equipment ID:</td>
              <td>
                {{ restartForm.equipment_id }}
              </td>
            </tr>
            <tr>
              <td>Device ID:</td>
              <td>
                {{ restartForm.device_id }}
              </td>
            </tr>
            <tr>
              <td>Command:</td>
              <td>
                {{ restartForm.command }}
              </td>
            </tr>
          </v-simple-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue" text @click="confirmRestartExperiment"> Confirm </v-btn>
          <v-btn color="error" text @click="cancelRestartExperiment"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="resetDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Confirm Reseting Experiment Data?
        </v-card-title>

        <v-card-text>
          <v-simple-table>
            <tr>
              <td>Experiment:</td>
              <td>
                {{ resetForm.experiment }}
              </td>
            </tr>
            <tr>
              <td>Equipment ID:</td>
              <td>
                {{ resetForm.equipment_id }}
              </td>
            </tr>
            <tr>
              <td>Device ID:</td>
              <td>
                {{ resetForm.device_id }}
              </td>
            </tr>
          </v-simple-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue" text @click="confirmResetData"> Confirm </v-btn>
          <v-btn color="error" text @click="cancelResetData"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { Admin_APIService } from "@/services/Admin_APIService";
import { Experiment_APIService } from "@/services/Experiment_APIService";
const apiService = new Admin_APIService(process.env.VUE_APP_BASE_URL);
const expService = new Experiment_APIService(process.env.VUE_APP_BASE_URL);
export default {
  name: "AdminBooking",
  props: {},
  data: function () {
    return {
      restartShow: false,
      resetDataShow: false,
      dates: [],
      experiments: [
        { 
            header: "PHYSICS" 
        },
        {
            text:"APPARENT_DEPTH",
            value:"APPARENT_DEPTH"
        },
        {
            text:"EM_INDUCTION",
            value:"EM_INDUCTION"
        },
        {
            text:"INTERFERENCE",
            value:"INTERFERENCE"
        },
        {
            text:"PHOTO_ELECTRIC",
            value:"PHOTO_ELECTRIC"
        },
        {
            text:"RADIATION",
            value:"RADIATION"
        },
        {
            text:"ULTRASOUND",
            value:"ULTRASOUND"
        },
        {
            text:"NEW_INTERFERENCE",
            value:"NEW_INTERFERENCE"
        },
        {
            divider: true,
        },
        { 
            header: "CHEMISTRY" 
        },
        {
            text:"IDENTIFY_UNKNOWN_ANION",
            value:"IDENTIFY_UNKNOWN_ANION"
        },
        {
            text:"KINETIC_RATE",
            value:"KINETIC_RATE"
        },
        {
            text:"SPECTROPHOTOMETRY",
            value:"SPECTROPHOTOMETRY"
        },
        {
            text:"TITRATION",
            value:"TITRATION"
        },
        {
            text:"VISIBLE_SPECTRUM",
            value:"VISIBLE_SPECTRUM"
        },
        {
            divider: true,
        },
        { 
            header: "BIOLOGY" 
        },
        {
            text:"BACTERIA_GROWTH",
            value:"BACTERIA_GROWTH"
        },
        {
            text:"GREEN_HOUSE",
            value:"GREEN_HOUSE"
        },
        {
            text:"IODINE_TEST",
            value:"IODINE_TEST"
        },
        {
            text:"PHOTOSYNTHESIS",
            value:"PHOTOSYNTHESIS"
        },
        {
            text:"RESPIRATION",
            value:"RESPIRATION"
        },
        {
            divider: true,
        },
        { 
            header: "ENGINEERING" 
        },
        {
            text:"TENSILE_TEST",
            value:"TENSILE_TEST"
        },
        {
            text:"CAPACITANCE",
            value:"CAPACITANCE"
        },
      ],
      equipment_ids: [
        {
          text: "Set 0",
          value: "set_0",
        },
        {
          text: "Set 1",
          value: "set_1",
        },
        {
          text: "Set 2",
          value: "set_2",
        },
        {
          text: "Set 3",
          value: "set_3",
        },
        {
          text: "Set 4",
          value: "set_4",
        },
        {
          text: "Set 5",
          value: "set_5",
        },
        {
          text: "Set 6",
          value: "set_6",
        },
        {
          text: "Set 7",
          value: "set_7",
        },
      ],
      device_ids: [
        {
          text: "device_0",
          value: "device_0",
        },
        {
          text: "device_1",
          value: "device_1",
        },
      ],
      commands: [
        {
          text: "RESTART|1",
          value: "RESTART|1",
        },
        {
          text: "INIT|0",
          value: "INIT|0",
        },
      ],
      restartForm: {
        experiment: "",
        equipment_id: "",
        device_id: "",
        command: "",
      },
      resetForm: {
        experiment: "",
        equipment_id: "",
        device_id: "",
      },
      restartDialog: false,
      resetDialog: false,
    };
  },
  computed: {
  },
  methods: {        
    confirmRestartExperiment: function () {
      var self = this;
      expService.setCommand(
          'super',
          'super',
          self.restartForm.experiment,
          self.restartForm.equipment_id,
          self.restartForm.device_id,
          self.restartForm.command
      )
      .then((response) => {
          if(response.status == "success"){
            alert("Command to experiment: " + self.restartForm.experiment + " (" + self.restartForm.equipment_id + ", " + self.restartForm.device_id + ") is sent.");
            self.restartDialog = false;
          }
          else {
            alert("Fail. Command to " + self.restartForm.experiment + " (" + self.restartForm.equipment_id + ") does not send!");
          }          
      });
    },
    cancelRestartExperiment: function () {
      var self = this;
      self.restartDialog = false;
    },
    confirmResetData: function () {
      var self = this;
      expService.setDataToFile(
          self.resetForm.experiment,
          self.resetForm.equipment_id,
          self.resetForm.device_id,
          '[]'
      )
      .then((response) => {
          if(response.status == "success"){
            alert("Experiment Data: " + self.resetForm.experiment + " (" + self.resetForm.equipment_id + ", " + self.resetForm.device_id + ") is reset.");
            self.resetDialog = false;
          }
          else {
            alert("Fail. Experiment data of " + self.resetForm.experiment + " (" + self.resetForm.equipment_id + ") does not reset!");
          }          
      });
    },
    cancelResetData: function () {
      var self = this;
      self.resetDialog = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>